export const inboxForMeFlexPaneTitle = "fCa";
export default {inboxForMeFlexPaneTitle};